module.exports = __webpack_public_path__ + "static/media/bbe_title.86160e47.jpg";